// extracted by mini-css-extract-plugin
export default {"root":"PreviewAvatarMedia_root__Z6eTH","layout-container":"PreviewAvatarMedia_layout-container__yufVX","deployButton":"PreviewAvatarMedia_deployButton__evY1K","spinnerWrapper":"PreviewAvatarMedia_spinnerWrapper__HrPjz","avatarVideoContainer":"PreviewAvatarMedia_avatarVideoContainer__KWBiZ","previewUnavailable":"PreviewAvatarMedia_previewUnavailable__irzYL"};
    if(module.hot) {
      // 1763446807670
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  